import styled from 'styled-components'
import { ASSETS } from '../../../constants/assets'
import { setPaddingSize } from '../../../utils/contentfulStyles.utils'
import Typography from '../typography'

export const BlockContainer = styled.div<{
  $orangeDivider: boolean
  $quoteBlockTheme: string
  $topPadding: string
  $bottomPadding: string
  $centerAlignment: string
}>`
  ${({
    theme,
    $orangeDivider,
    $quoteBlockTheme,
    $topPadding,
    $bottomPadding,
    $centerAlignment,
  }) => {
    let innerStyles = `
      padding-top: ${setPaddingSize($topPadding)}px;
      padding-bottom: ${setPaddingSize($bottomPadding)}px;
    `

    let divider = ``
    if ($orangeDivider) {
      divider += `
        .paragrapghBlock__Title_container:before {
          content: '';
          position: absolute;
          width: 160px;
          height: 4px;
          background: ${theme.webMktNewPalette.orange[50]};
        }
      `
    }

    let alignment = ``
    if ($centerAlignment) {
      alignment += `
        text-align: center;
        .paragrapghBlock__Title_container {
          margin: 0 auto;
          &:before {
            left: 50%;
            transform: translateX(-50%);
          }
        }
      `
    }

    return `
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: ${
        $quoteBlockTheme === 'Light'
          ? theme.webMktNewPalette.white
          : theme.webMktNewPalette.deepBlue[10]
      };
      box-sizing: border-box;
      ${innerStyles}
      ${divider}
      ${alignment}

      .FeaturedAsset__Text-Container{
        background: ${
          $quoteBlockTheme === 'Light'
            ? theme.webMktNewPalette.deepBlue[10]
            : theme.webMktNewPalette.white
        }; 
      }
      .ParagraphBlock__Container {
        margin: 64px 0;
        max-width: 632px;

        ${theme.breakpoints.down('sm')} {
          max-width: 533px;
        }
      }
      
      .LineBreak {
        ${({ theme }: any) => theme.breakpoints.down('xs')} {
          display: block;
        }
      }

      ul {
        list-style: disc;
      }


     .inline-formatter {
        display: inline;
      }
      a + span {
        display: inline;
      }
        a + span.LineBreak {
          min-height: auto;
        }

      .quote-container {
        background: ${
          $quoteBlockTheme === 'Light'
            ? theme.webMktNewPalette.deepBlue[10]
            : theme.webMktNewPalette.white
        };
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 32px;
        position: relative;
        margin: 48px 0;
        letter-spacing: -0.5px;

        ${theme.breakpoints.down('xs')} {
          font-size: 20px;
          line-height: 32px;
        }
      }

      .is-quote {
        margin-top: 80px;
      }

      .is-quote:before {
        content: '';
        background-image: url(${ASSETS.BLOCKQUOTE});
        background-repeat: no-repeat, repeat;
        position: absolute;
        width: 100%;
        height: 64px;
        top: -31px;
        left: 48px;
      }

      .is-quote > p:first-child {
        margin: 32px 0;
      }

      .is-quote > p:last-child {
        margin: 0;
      }
    `
  }}
`

export const BlockTitle = styled(Typography)`
  white-space: pre-line;
  padding: 48px 0 32px 0;
`
